export const GLOBAL_CONSTANT = {
  WEEK_DAYS: [
    { label: "Sunday", value: 0 },
    { label: "Monday", value: 1 },
    { label: "Tuesday", value: 2 },
    { label: "Wednesday", value: 3 },
    { label: "Thursday", value: 4 },
    { label: "Friday", value: 5 },
    { label: "Saturday", value: 6 },
  ],
  EDUCATION_TYPE: [
    { label: "10th Pass", value: "PASS_10TH" },
    { label: "12th Pass", value: "PASS_12TH" },
    { label: "Graduate", value: "GRADUATE" },
    { label: "Post Graduate", value: "POST_GRADUATE" },
    { label: "Under Graduate", value: "UNDER_GRADUATE" },
  ],
  
  BLOODGROUP_TYPE: [
    { label: "A +Ve ", value: "A+" },
    { label: "A -Ve", value: "A-" },
    { label: "B +Ve", value: "B+" },
    { label: "B -Ve", value: "B-" },
    { label: "O +Ve", value: "O+" },
    { label: "O -Ve", value: "O-" },
    { label: "AB +Ve", value: "AB+" },
    { label: "AB -Ve", value: "AB-" },
  ],

  MODE_TYPE: [
    { label: "SMS", value: "SMS" },
    { label: "Whatsapp", value: "Whatsapp" },
    { label: "Email", value: "Email" },
  ],

  PRIORITY_CONSTANT: [
    { label: "High", value: "HIGH" },
    { label: "Medium", value: "MEDIUM" },
    { label: "Low", value: "LOW" },
  ],
  STATUS_CONSTANT: [
    { label: "Proposed", value: "PROPOSED" },
    { label: "Solved", value: "SOLVED" },
    { label: "In-progress", value: "INPROGRESS" },
    { label: "Hold", value: "HOLD" },
  ],
  GENDER_TYPES: [
    { label: "Male", value: "MALE", icon: "man" },
    { label: "Female", value: "FEMALE", icon: "woman" },
    { label: "Other", value: "OTHER", icon: "other" },
  ],
  VOTER_TYPES: [
    { label: "Our Voter", value: true, icon: "isVoter" },
    { label: "Non Voter", value: false, icon: "isVoterred" },
  ],
  ENTRY_TYPES: [
    { label: "Inward", value: "INWARD" },
    { label: "Outward", value: "OUTWARD" },
  ],
  CITY_TYPES: [
    { label: "Village", value: "VILLAGE" },
    { label: "City", value: "CITY" },
  ],
  RATIONCARD_DATA: [
    { label: "No Card", value: "NO CARD", color: "No" },
    { label: "White", value: "WHITE", color: "white" },
    { label: "Yellow", value: "YELLOW", color: "yellow" },
    { label: "Orange", value: "ORANGE", color: "orange" },
  ],
  OPTION_TYPE: [
    { label: "Attended", value: "ATTENDED" },
    { label: "Not Attended", value: "NOTATTENDED" },
    { label: "Not Marked", value: "NOTMARKED" },
  ],
  OPTION_TYPE1: [
    { label: "Attended", value: "ATTENDED" },
    { label: "Not Attended", value: "NOTATTENDED" },
  ],
  DATA_TYPE: [
    { label: "All Events", value: "all" },
    { label: "Past Events", value: "past" },
    { label: "Upcoming Events", value: "upcoming" },
  ],
  AGE_TYPE: [
    { label: "Date Of Birth", value: "dob" },
    { label: "Date of Expiry", value: "doe"},
    { label: "Age", value: "age" },
  ],
  COMPLAIN_STATUS: [
    { label: "Solved", value: "SOLVED" },
    { label: "Inprogress", value: "INPROGRESS" },
    { label: "Hold", value: "HOLD" },
    { label: "Unsolved", value: "UNSOLVED" },
    { label: "Queue", value: "QUEUE" },
    { label: "STatus Update", value: "STATUSUPDATEREQUESTED"}
  ],
  UNSOLVED_STATUS: [
    { label: "Solved", value: "SOLVED" },
    { label: "Inprogress", value: "INPROGRESS" },
    { label: "Hold", value: "HOLD" },
    { label: "Unsolved", value: "UNSOLVED" },
    { label: "Queue", value: "QUEUE" },
  ],
  INPROGRESS_STATUS: [
    { label: "Solved", value: "SOLVED" },
    { label: "Hold", value: "HOLD" },
  ],
  HOLD_STATUS: [
    { label: "Unsolved", value: "UNSOLVED" },
    { label: "Inprogress", value: "INPROGRESS" },
  ],
  QUEUE_STATUS: [
    { label: "Inprogress", value: "INPROGRESS" },
    { label: "Hold", value: "HOLD" },
  ],
  COMPLAIN_OPTIONS: [
    { label: "By Details", value: "voterDetails" },
    { label: "By Voter ID", value: "voterID" },
  ],

  VISITOR_PURPOSE: [
    { label: "General Visit", value: "GENERAL_VISIT" },
    { label: "Complaint", value: "COMPLAIN" },
    { label: "Invitation", value: "INVITATION" },
    { label: "Register Book", value: "REGISTER_BOOK" },
    { label: "Schedule Book", value: "SCHEDULE_BOOK" },
    { label: "Call Log", value: "CALL_LOG" },
  ],
  ACTIVE_INACTIVE: [
    { label: "Active", value: "1" },
    { label: "In-Active", value: "0" },
  ],
  YES_NO: [
    { label: "Yes", value: "yes" },
    { label: "No", value: "no" },
  ],
  KIOSK_COLS: [
    { field: "uniqueID", header: "uniqueID" },
    { field: "password", header: "Password" },
    { field: "name", header: "Name" },
    { field: "working", header: "Working Status" },
    { field: "status", header: "Status" },
    // { field: "action", header: "Action" }
  ],
  SORTBY_OPTION: [
    { name: "Date", code: "NY" },
    { name: "Name", code: "RM" },
    { name: "Category", code: "LDN" },
  ],
  PRIORITY_TYPES: [
    { label: "VIP", value: "VIP" },
    { label: "Important", value: "IMPORTANT" },
    { label: "Regular", value: "REGULAR" },
  ],
  PUBLIC_COMPLAINT: [
    { label: "पाणी", value: "Pani" },
    { label: "वीज", value: "Light" },
    { label: "ड्रेनेज", value: "Drainage" },
    { label: "रस्ते", value: "Raste" },
    { label: "साफसफाई (कचरा उचलने)", value: "Safsafai" },
    { label: "झाडे (झाडे कापणे व कापलेली झाडे उचलणे)", value: "Zade" },
    { label: "डेंग्यू फवारणी", value: "Dengue_Favarni" },
    { label: "महापालिके संदर्भात", value: "Mahapalike_sandarbhat" },
    { label: "इतर", value: "Itar" },
  ],
  FLAG_DATE: [
    { name: "Regular", value: "regular" },
    { name: "End Date", value: "endDate" },
  ],
  FIELD_OPTIONS: [
    { label: "Input", code: "input" },
    { label: "Checkbox", code: "checkbox" },
  ],
  KAL_OPTIONS:[
    { label: "Green", value: "Green" },
    { label: "Yellow", value: "Yellow" },
    { label: "Red", value: "Red" },
    { label: "Strong", value: "Strong" },
    { label: "Weak", value: "Weak" },


  ],
  // --------------Google sitekey-----------
  CAPTCHA_KEY: "6Lc8NRocAAAAABeAL5-wxXrLOrIPpijpXfpMXp1r",
};
